/* ============================================================
   Fuji Hydration — theme interactions
   Mobile nav · scroll reveal · variant selection ·
   AJAX add-to-cart · slide-out cart drawer (with +/- steppers)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Money formatting ----------
     Uses the shop's own currency format instead of a hardcoded "₱".
     Expose the format from your layout with Liquid, e.g. in theme.liquid:

       <script>
         window.theme = window.theme || {};
         window.theme.moneyFormat = {{ shop.money_format | json }};
       </script>

     If Shopify's formatMoney (from option_selection.js) is present it is
     used directly; otherwise the same algorithm is applied as a fallback.  */
  var moneyFormat =
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    '₱{{amount}}';

  function formatMoney(cents, format) {
    var fmt = format || moneyFormat;

    // Prefer Shopify's native formatter when it's available.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, fmt);
    }

    // --- Fallback: port of Shopify.formatMoney ---
    if (typeof cents === 'string') cents = cents.replace('.', '');

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal = (typeof decimal === 'undefined') ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsPart;
    }

    var value = '';
    var match = fmt.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ','); break;
      default:
        value = withDelimiters(cents, 2);
    }

    return fmt.replace(placeholderRegex, value);
  }

  /* ---------- Mobile nav toggle ---------- */
  var toggle = document.querySelector('.header__toggle, [data-nav-toggle]');
  var nav = document.querySelector('.header__nav, [data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-animate]').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Product variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var root = form.closest('.product') || form.parentElement;
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-btn]');

    function currentOptions() {
      var opts = [];
      // Radio pills grouped by data-option-index
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        if (group.tagName === 'SELECT') {
          opts[idx] = group.value;
        } else {
          var checked = group.querySelector('input:checked');
          if (checked) opts[idx] = checked.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(opts[i]); });
      });
    }

    function update() {
      var opts = currentOptions();
      var v = findVariant(opts) || variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = typeof v.price === 'number' ? formatMoney(v.price) : v.price;
      if (compareEl) {
        var showCompare = v.compare_at && v.compare_at !== v.price;
        compareEl.textContent = showCompare
          ? (typeof v.compare_at === 'number' ? formatMoney(v.compare_at) : v.compare_at)
          : '';
        compareEl.style.display = showCompare ? '' : 'none';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-label-add') || 'Add to cart') : 'Sold out';
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var evt = group.tagName === 'SELECT' ? 'change' : 'change';
      group.addEventListener(evt, update);
    });
    update();
  });

  /* ---------- Cart drawer ---------- */
  function openCart() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (d) d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Expose the cart drawer so opt-in sections (e.g. the urgency pop-up's
     add-to-cart CTA) can open it / re-sync it after an AJAX add or discount. */
  window.theme = window.theme || {};
  window.theme.openCart = openCart;
  window.theme.refreshCart = refreshCart;

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
        var sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = formatMoney(cart.total_price);

        // Applied discount codes shown in the drawer.
        var disc = document.querySelector('[data-cart-discounts]');
        if (disc) {
          var apps = cart.cart_level_discount_applications || [];
          disc.innerHTML = apps.map(function (d) {
            var right = '&minus;' + formatMoney(d.total_allocated_amount);
            var title = String(d.title).replace(/"/g, '&quot;');
            var remove = d.type === 'discount_code'
              ? '<button type="button" data-discount-remove="' + title + '" aria-label="Remove discount ' + title + '" style="background:none;border:0;color:var(--color-muted);cursor:pointer;font-size:1.05rem;line-height:1;padding:0 2px;">&times;</button>'
              : '';
            return '<div class="cart-drawer__discount" style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:8px;font-size:.9rem;font-weight:600;color:var(--color-success,#38A169);">' +
              '<span style="display:flex;align-items:center;gap:6px;">' + remove + '<span>' + d.title + '</span></span>' +
              '<span>' + right + '</span></div>';
          }).join('');
        }
        var body = document.querySelector('[data-cart-body]');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
          return;
        }
        body.innerHTML = cart.items.map(function (i) {
          var img = i.image
            ? '<img src="' + i.image.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="" width="64" height="64" style="border-radius:10px;object-fit:cover;">'
            : '';
          return '<div class="cart-line" data-key="' + i.key + '" style="display:flex;gap:12px;margin-bottom:18px;align-items:flex-start;">' +
            img +
            '<div style="flex:1;">' +
              '<a href="' + i.url + '" style="font-weight:700;color:var(--color-navy);">' + i.product_title + '</a>' +
              (i.variant_title && i.variant_title !== 'Default Title' ? '<div style="font-size:.85rem;color:var(--color-muted);">' + i.variant_title + '</div>' : '') +
              // --- quantity stepper + line total ---
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:6px;">' +
                '<div class="cart-line__qty" style="display:inline-flex;align-items:center;border:1px solid var(--color-navy);border-radius:6px;overflow:hidden;">' +
                  '<button type="button" data-qty-minus aria-label="Decrease quantity" style="width:28px;height:28px;border:0;background:transparent;font-size:16px;line-height:1;cursor:pointer;color:var(--color-navy);">&minus;</button>' +
                  '<span data-qty-num style="min-width:32px;text-align:center;font-weight:600;font-size:.9rem;">' + i.quantity + '</span>' +
                  '<button type="button" data-qty-plus aria-label="Increase quantity" style="width:28px;height:28px;border:0;background:transparent;font-size:16px;line-height:1;cursor:pointer;color:var(--color-navy);">+</button>' +
                '</div>' +
                '<span style="font-weight:600;font-size:.9rem;">' + formatMoney(i.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-cart-remove="' + i.key + '" style="background:none;border:0;color:var(--color-muted);text-decoration:underline;cursor:pointer;font-size:.8rem;padding:4px 0;">Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');
      });
  }

  /* ---------- Discount codes (apply / remove, persist to checkout) ---------- */
  var discountBusy = false;

  // Currently applied code-based discounts, read from the live cart.
  function appliedCodes(cart) {
    return (cart.cart_level_discount_applications || [])
      .filter(function (d) { return d.type === 'discount_code'; })
      .map(function (d) { return d.title; });
  }

  // Apply ONE discount code. Shopify's /discount/<code> endpoint takes a single code
  // and STACKS it onto any existing combinable codes — it is not a comma-separated
  // list (that reads as one invalid code) and it does not replace what's applied.
  function applyOneCode(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    });
  }

  // Cart page is server-rendered, so reload to show new totals; elsewhere re-sync the drawer.
  function reflectCart() {
    if (document.querySelector('[data-cart-page]')) window.location.reload();
    else refreshCart();
  }

  function addDiscount(code) {
    code = (code || '').trim();
    if (!code || discountBusy) return;
    discountBusy = true;
    applyOneCode(code)
      .catch(function () {})
      .then(function () { discountBusy = false; reflectCart(); });
  }

  function removeDiscount(code) {
    if (discountBusy) return;
    discountBusy = true;
    var target = String(code).toLowerCase();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var remaining = appliedCodes(cart).filter(function (c) { return c.toLowerCase() !== target; });
        // /discount can't remove a single code, so clear all, then re-apply the rest one by one.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).then(function () {
          return remaining.reduce(function (p, c) {
            return p.then(function () { return applyOneCode(c); });
          }, Promise.resolve());
        });
      })
      .catch(function () {})
      .then(function () { discountBusy = false; reflectCart(); });
  }

  document.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-discount-remove]');
    if (rem) { e.preventDefault(); removeDiscount(rem.getAttribute('data-discount-remove')); return; }

    var apply = e.target.closest('[data-discount-apply]');
    if (apply) {
      e.preventDefault();
      var wrap = apply.closest('[data-discount-form]');
      var input = wrap && wrap.querySelector('[data-discount-input]');
      if (input) addDiscount(input.value);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      addDiscount(e.target.value);
    }
  });

  /* Guard against overlapping requests when a stepper is clicked rapidly. */
  var cartBusy = false;
  function changeQty(key, qty) {
    if (cartBusy) return;
    cartBusy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); })
      .catch(function () {})
      .then(function () { cartBusy = false; }); // runs on success or failure (acts as finally)
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }

    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeQty(rm.getAttribute('data-cart-remove'), 0); }

    // --- quantity steppers ---
    var step = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (step) {
      e.preventDefault();
      var line = step.closest('[data-key]');
      if (line) {
        var cur = parseInt(line.querySelector('[data-qty-num]').textContent, 10) || 0;
        var next = step.hasAttribute('data-qty-plus') ? cur + 1 : cur - 1;
        changeQty(line.getAttribute('data-key'), Math.max(0, next)); // 0 removes the line
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.submit();
      });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.getElementById('ProductMainImage');
    if (main) main.src = thumb.getAttribute('data-thumb');
    var group = thumb.parentElement;
    group.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
  if (document.readyState !== 'loading') refreshCart();
})();